import { render, staticRenderFns } from "./SubjectOverview.vue?vue&type=template&id=24bbf3a5&scoped=true&"
import script from "@/components/subject-overview/SubjectOverview.ts?vue&type=script&lang=ts&"
export * from "@/components/subject-overview/SubjectOverview.ts?vue&type=script&lang=ts&"
import style0 from "@/components/subject-overview/subject-overview.scss?vue&type=style&index=0&id=24bbf3a5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24bbf3a5",
  null
  
)

export default component.exports